import { render, staticRenderFns } from "./index_90s.vue?vue&type=template&id=04c51171&scoped=true&"
import script from "./index_90s.vue?vue&type=script&lang=js&"
export * from "./index_90s.vue?vue&type=script&lang=js&"
import style0 from "./index_90s.vue?vue&type=style&index=0&id=04c51171&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04c51171",
  null
  
)

export default component.exports